(function () {
  const mq = window.matchMedia("(max-width: 749px)");
  let activeItem = null;
  let rafId = null;
  let container = null;

  const closeActive = () => {
    if (activeItem) activeItem.classList.remove("is-touch", "is-open");
    activeItem = null;
  };

  const openItem = (item) => {
    if (!item) return;

    if (activeItem && activeItem !== item) {
      activeItem.classList.remove("is-touch", "is-open");
    }

    activeItem = item;
    activeItem.classList.add("is-touch", "is-open");
  };

  const itemFromTouch = (touch) => {
    const el = document.elementFromPoint(touch.clientX, touch.clientY);
    return el ? el.closest(".ps-rb__item") : null;
  };

  // Global: if finger is outside the section while moving/scrolling -> close
  const handleGlobalTouch = (e) => {
    if (!mq.matches) return;
    if (!activeItem) return;
    if (!e.touches || !e.touches.length) return;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      const t = e.touches[0];
      const el = document.elementFromPoint(t.clientX, t.clientY);

      // If we can't resolve an element, do nothing (rare), but if we can and it's outside -> close
      if (el && !el.closest(".ps-rb")) {
        closeActive();
      }
    });
  };

  const handleTouchInside = (e) => {
    if (!mq.matches) return;
    if (!e.touches || !e.touches.length) return;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      const item = itemFromTouch(e.touches[0]);
      if (item) openItem(item);
    });
  };

  const init = () => {
    if (!mq.matches) return;

    container = document.querySelector(".ps-rb");
    if (!container) return;

    // Inside the section: reveal on touch
    container.addEventListener("touchstart", handleTouchInside, { passive: true });
    container.addEventListener("touchmove", handleTouchInside, { passive: true });

    // Tap on banner keeps it open (buttons excluded)
    container.addEventListener(
      "click",
      (e) => {
        const item = e.target.closest(".ps-rb__item");
        if (!item) return;

        if (e.target.closest(".ps-rb__btn")) return;

        openItem(item);
      },
      true
    );

    // Click outside closes (desktop + mobile taps)
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".ps-rb")) closeActive();
    });

    // Critical part: capture-phase global touch tracking
    // This keeps firing even when finger leaves the section during scroll.
    document.addEventListener("touchstart", handleGlobalTouch, { passive: true, capture: true });
    document.addEventListener("touchmove", handleGlobalTouch, { passive: true, capture: true });

    // Optional: also close when scrolling via momentum (no active touch)
    window.addEventListener(
      "scroll",
      () => {
        if (!mq.matches) return;
        if (!activeItem) return;

        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const r = container.getBoundingClientRect();
          const visible = r.bottom > 0 && r.top < window.innerHeight;
          if (!visible) closeActive();
        });
      },
      { passive: true }
    );
  };

  window.addEventListener("load", init);
})();
